class PageMain {
  constructor(mainElement) {
    this.mainElement = mainElement;
    this.calcAndSetMinHeight();
  }

  calcAndSetMinHeight() {
    const pageHeader = document.querySelector('.header');
    const pageHeaderHeight = pageHeader ? pageHeader.offsetHeight : 0;
    const pageFooter = document.querySelector('.footer');
    const pageFooterHeight = pageFooter ? pageFooter.offsetHeight : 0;
    const windowHeight = window.innerHeight;

    this.mainElement.style.minHeight = `${windowHeight - pageHeaderHeight - pageFooterHeight}px`;
  }
}

export default PageMain;
